import { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import { setDocumentTitle } from "@/lib/documentTitle";

import { E3PortfoliosEdit } from "./edit";
import { E3PortfoliosNew } from "./new";
import { E3PortfoliosTable } from "./table";
export default function E3Portfolios() {
  useEffect(() => {
    setDocumentTitle("Quantilia | Portefeuilles");
  }, []);

  return (
    <Routes>
      <Route path=":id" element={<E3PortfoliosEdit />} />
      <Route index element={<E3PortfoliosTable />} />
      <Route path="/new" element={<E3PortfoliosNew />} />
    </Routes>
  );
}
